import { useSelector } from 'react-redux';
import isNil from 'lodash/isNil';
import {
  VIEW_ADMIN,
  DO_IMPERSONATION,
} from 'shared/../constants/UserAccess';

const useCurrentUser = () => {
  const currentUser = useSelector(({ user }) => user);

  const {
    isLoading, error, id, email, name, userAccess, username, features, properties,
  } = currentUser;

  const canImpersonate = (checkCurrentImpersonation = true) => {
    if (checkCurrentImpersonation) {
      const impersonateUser = sessionStorage.getItem('impersonate')
        ? JSON.parse(sessionStorage.getItem('impersonate')) : null;

      if (impersonateUser) {
        return false;
      }
    }
    return userAccess[VIEW_ADMIN] || userAccess[DO_IMPERSONATION];
  };

  const hasAccessTo = (modes) => {
    const modesItems = Array.isArray(modes) ? modes : [modes];
    const impersonateUser = sessionStorage.getItem('impersonate') ?
      JSON.parse(sessionStorage.getItem('impersonate')) : null;

    if (canImpersonate(false) && impersonateUser) {
      const privileges = new Set(impersonateUser.privileges);
      return modesItems.every((mode) => privileges.has(mode));
    }

    return userAccess && modesItems.every((mode) => userAccess[mode]);
  };

  const impersonationInfo = sessionStorage.getItem('impersonate')
    ? JSON.parse(sessionStorage.getItem('impersonate')) : null;

  const hasAnyAccessTo = (modes) => {
    const modesItems = Array.isArray(modes) ? modes : [modes];
    const impersonateUser = sessionStorage.getItem('impersonate')
      ? JSON.parse(sessionStorage.getItem('impersonate')) : null;

    if (canImpersonate(false) && impersonateUser) {
      const privileges = new Set(impersonateUser.privileges);
      return modesItems.findIndex((mode) => privileges.has(mode)) > -1;
    }

    return userAccess && modesItems.findIndex((mode) => userAccess[mode]) > -1;
  };

  const startImpersonate = (user) => {
    sessionStorage.setItem('impersonate', JSON.stringify(user));
  };

  const stopImpersonate = () => {
    sessionStorage.removeItem('impersonate');
  };

  return {
    isUserLoading: isLoading,
    isFailed: !isNil(error) && !isLoading,
    userLoadingErrorMsg: error,
    isUserLoaded: !isLoading && isNil(error),
    userId: id,
    userFullName: name,
    userEmail: email,
    userFeatures: features,
    userProperties: properties,
    systemUserName: username,
    userAccess,
    hasAccessTo,
    hasAnyAccessTo,
    canImpersonate,
    startImpersonate,
    impersonationInfo,
    stopImpersonate,
  };
};

export default useCurrentUser;
